import React from "react";

function MobileExistsFeedback({
  exists = false,
  checking = false,
  message = "Mobile number already exists",
  className = "",
}) {
  if (checking) {
    return (
      <small className={`text-muted d-block mt-1 ${className}`} style={{ fontSize: "0.75rem" }}>
        Checking mobile...
      </small>
    );
  }

  if (!exists) return null;

  return (
    <small className={`text-danger d-block mt-1 ${className}`} style={{ fontSize: "0.75rem" }}>
      {message}
    </small>
  );
}

export default MobileExistsFeedback;
